import React from "react";
import { IconButton, makeStyles } from "@material-ui/core";
import { useFontSize } from "../../context/FontSizeContext";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  button: {
    marginRight: 8,
    width: 40,
    height: 30,
    padding: 0,
    fontSize: 16,
    fontWeight: "bold",
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.text.border}`,
    borderRadius: 8,
    backgroundColor: "transparent",
    transition: "background-color 0.3s, transform 0.2s",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

const FontSizeControls = ({ containerClass, buttonClass }) => {
  const { increaseFont, decreaseFont, resetFont } = useFontSize();
  const classes = useStyles();

  return (
    <div className={containerClass || classes.container}>
      <IconButton
        onClick={decreaseFont}
        className={buttonClass || classes.button}
        aria-label="Decrease Font"
      >
        A-
      </IconButton>
      <IconButton
        onClick={resetFont}
        className={buttonClass || classes.button}
        aria-label="Reset Font"
      >
        A
      </IconButton>
      <IconButton
        onClick={increaseFont}
        className={buttonClass || classes.button}
        aria-label="Increase Font"
      >
        A+
      </IconButton>
    </div>
  );
};

export default FontSizeControls;
